import { env } from '@/services/dev';
import utils from '@/services/tools';
import http from '@/services/http';

export default {
  // 获取飞书文件夹下的文件列表
  getFeishuFolderFileList(params) {
    return http
      .wwxPost(`${env.apiBase}/wwx/feishu_folder_get`, params)
      .then((res) => {
        const { data, err } = utils.getResponseData(res);
        if (err) {
          utils.showError(err);
          return Promise.reject(err);
        }
        return data;
      });
  },

  // 获取发送企微消息对话框的mediaid
  getChatMessageMediaid(params) {
    return http
      .wwxPost(`${env.apiBase}/wwx/feishu_file_download`, params)
      .then((res) => {
        const { data, err } = utils.getResponseData(res);
        if (err) {
          utils.showError(err);
          return Promise.reject(err);
        }
        return data;
      });
  },
  // 搜索飞书文件列表
  searchFileList(params) {
    return http.wwxPost('/wwx/feishu_file_search', params, {
      notParse: false,
      noToast: false,
    });
  },
};
